import React, { useState, useEffect, useCallback } from 'react'
import { Modal, Form, Input, Space, Radio, Steps, App, Select   } from 'antd'
import { useKPSQspjdUpdateQuery, useKPSQspjdUpdateSaveMutation, useKPSQspjdDelMutation } from '../../../store/DianShangYeWuApi'   
import Icon from '../../../cpn/Icon'
function RuleInvoiceEdit(props) {    
    const useList = props.useList.map(item => ({value:item.yh_id,label:item.yh_name,key:item.yh_id}));
    const deptList = props.deptList.map(item => ({value:item.d_id,label:item.d_name,key:item.d_id}));
        const [form] = Form.useForm();
    const {message,modal} = App.useApp();
    const [open, setOpen] = useState(false);
    const [info, setInfo] = useState({
        kpsq_spjd_content: '',
        kpsq_spjd_bm_id: '',
        kpsq_spjd_bm_name: '',
        kpsq_spjd_user_id: '',
        kpsq_spjd_user_name: '',
        kpsq_spjd_zflx: '无',
        kpsq_spjd_amount_min: '无',
        kpsq_spjd_amount_max: '无',
    });
                    const {data, isSuccess} = useKPSQspjdUpdateQuery({kpsq_spjd_id:props.kpsq_spjd_id});
    useEffect(() => {
        if(isSuccess && data.Status === 'success' && data.Result){
            setInfo(data.Result);
            form.setFieldsValue({
                kpsq_spjd_content: data.Result.kpsq_spjd_content,
                kpsq_spjd_bm_id: data.Result.kpsq_spjd_bm_id,
                kpsq_spjd_bm_name: data.Result.kpsq_spjd_bm_name,
                kpsq_spjd_user_id: data.Result.kpsq_spjd_user_id,
                kpsq_spjd_user_name: data.Result.kpsq_spjd_user_name,
                kpsq_spjd_zflx: data.Result.kpsq_spjd_zflx,
                kpsq_spjd_amount: data.Result.kpsq_spjd_amount,
            });
            
            // 解析审批点数据并设置为默认值
            if(data.Result.kpsq_spjd_name && data.Result.kpsq_spjd_yh_id && data.Result.kpsq_spjd_yh_name){
                const names = data.Result.kpsq_spjd_name.split(',');
                const userIds = data.Result.kpsq_spjd_yh_id.split(',');
                const userNames = data.Result.kpsq_spjd_yh_name.split(',');
                
                const nodes = names.map((name, index) => ({
                    title: name + '：' + (userNames[index] || ''),
                    content: '',
                    status: 'wait',
                    kpsq_spjd_name: name,
                    kpsq_spjd_yh_id: userIds[index] || '',
                    kpsq_spjd_yh_name: userNames[index] || '',
                }));
                
                setNewNode(nodes);
            }
        }
    }, [data, isSuccess, form])
    const [newNode, setNewNode] = useState([]);
    const [items, setItems] = useState([]);
    const [submitUpdate] = useKPSQspjdUpdateSaveMutation();
    const [editNodeModalOpen, setEditNodeModalOpen] = useState(false);
    const [editingNodeIndex, setEditingNodeIndex] = useState(-1);
    const [editNodeForm] = Form.useForm();
    const [editNodeInfo, setEditNodeInfo] = useState({
        node_type: '',
        node_user_id: '',
        node_user_name: '',
    }); 
    const handleEditNode = useCallback((index) => {
        const node = newNode[index];
        setEditingNodeIndex(index);
        const nodeInfo = {
            node_type: node.kpsq_spjd_name,
            node_user_id: node.kpsq_spjd_yh_id,
            node_user_name: node.kpsq_spjd_yh_name,
        };
        setEditNodeInfo(nodeInfo);
        setEditNodeModalOpen(true);
        // 延迟设置表单值，确保 Modal 已经打开
        setTimeout(() => {
            editNodeForm.setFieldsValue({
                node_type: node.kpsq_spjd_name,
                node_user_id: node.kpsq_spjd_yh_id,
            });
        }, 100);
    }, [newNode, editNodeForm]);
    
    const handleDeleteNode = useCallback((index) => {
        setNewNode(prev => prev.filter((_, i) => i !== index));
    }, []);
    
    useEffect(() => {
        setItems(
            newNode.map((node, index) => ({
                ...node,
                subTitle: (
                    <Space>
                        <a onClick={() => handleEditNode(index)}>修改</a>
                        <a onClick={() => handleDeleteNode(index)} style={{color: 'red'}}>删除</a>
                    </Space>
                )
            }))
        );
    }, [newNode, handleEditNode, handleDeleteNode]);
    
    const handleSaveEditNode = () => {
        if(!editNodeInfo.node_type){
            message.error('请选择节点类型');
            return;
        }
        if(!editNodeInfo.node_user_name){
            message.error('请选择操作员');
            return;
        }
        
        setNewNode(prev => prev.map((node, index) => 
            index === editingNodeIndex 
                ? {
                    title: editNodeInfo.node_type + '：' + editNodeInfo.node_user_name,
                    content: '',
                    status: 'wait',
                    kpsq_spjd_name: editNodeInfo.node_type,
                    kpsq_spjd_yh_id: editNodeInfo.node_user_id,
                    kpsq_spjd_yh_name: editNodeInfo.node_user_name,
                }
                : node
        ));
        setEditNodeModalOpen(false);
        setEditingNodeIndex(-1);
        editNodeForm.resetFields();
        setEditNodeInfo({
            node_type: '',
            node_user_id: '',
            node_user_name: '',
        });
    };
    const onUpdate = () => {
        if(!info.kpsq_spjd_content){
            message.error('请输入规则名称');
            return;
        }
        if(!info.kpsq_spjd_bm_id){
            message.error('请选择部门');
            return;
        }
        let obj ={
            'kpsq_spjd_id': props.kpsq_spjd_id,
            'kpsq_spjd_qy_id': props.qy_id,
            'kpsq_spjd_qy_name': props.qy_name,
            'kpsq_spjd_xuhao': '',
            'kpsq_spjd_name': '',
            'kpsq_spjd_yh_id': '',
            'kpsq_spjd_yh_name': '',
            'kpsq_spjd_uid': props.yh_id,
            'kpsq_spjd_uname': props.yh_name,
            'kpsq_spjd_content': info.kpsq_spjd_content,
            'kpsq_spjd_user_id': info.kpsq_spjd_user_id,
            'kpsq_spjd_user_name': info.kpsq_spjd_user_name,
            'kpsq_spjd_bm_id': info.kpsq_spjd_bm_id,
            'kpsq_spjd_bm_name': info.kpsq_spjd_bm_name,
        }
        
        // 2. 校验 items 节点
        if (!items || items.length === 0 || (items.length === 1 && !items[0].kpsq_spjd_yh_id)) {
            message.error("请设置至少一个审批/抄送节点");
            return;
        }
        // 3. 过滤掉无效节点
        const validItems = items.filter(item => !!item.kpsq_spjd_yh_id && !!item.kpsq_spjd_yh_name);

        // 4. 填充 obj 字段
        // 不需要前面1,2两个元素了，直接从items的第一个开始
        // 填充序号
        let s = validItems.length;
        let xuhaoArr = [];
        for(let i=1; i<=s; ++i) xuhaoArr.push(i);
        obj.kpsq_spjd_xuhao = xuhaoArr.join(',');

        // 填充kpsq_spjd_name
        obj.kpsq_spjd_name = validItems.map(item => item.kpsq_spjd_name).join(',');

        // 填充kpsq_spjd_yh_id
        obj.kpsq_spjd_yh_id = validItems.map(item => item.kpsq_spjd_yh_id).join(',');

        // 填充kpsq_spjd_yh_name
        obj.kpsq_spjd_yh_name = validItems.map(item => item.kpsq_spjd_yh_name).join(',');

       

        // 5. 提交
        submitUpdate(obj).then(res => {
            if (res && res.data && res.data.Status === 'success') {
                message.success('更新成功');
                setOpen(false);
                setNewNode([]);
                setItems([]);
                setInfo({...info, 'kpsq_spjd_user_id':'', 'kpsq_spjd_user_name':''});
                props.onSuccess && props.onSuccess();
            } else {
                message.error('更新失败：' + (res?.data?.Message || '未知错误'));
            }
        });
    }
    const [submitDelete] = useKPSQspjdDelMutation();
    const onDelete = () => {
       modal.confirm({
            title: '删除',
            content: '确定删除吗？',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk: () => {
                submitDelete({
                    'kpsq_spjd_id': props.kpsq_spjd_id,
                }).then(res => {
                    if (res && res.data && res.data.Status === 'success') {
                        message.success('删除成功');
                        setOpen(false);
                        setNewNode([]);
                        setItems([]);
                        props.onSuccess && props.onSuccess();
                    }
                });
            }
        });
    }
    return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.kpsq_spjd_content}</a>
            <Modal
                title='修改'
                open={open}
                onCancel={() => {
                    setOpen(false);
                    setNewNode([]);
                    setItems([]);
                }}
                width={800}
                footer={null}
                destroyOnHidden={false}
                forceRender
            >
                <Form form={form} layout='horizontal' labelCol={{ span: 6 }} name={`ruleReportEditForm_${props.kpsq_spjd_id}`}>
                    <Form.Item label='开票申请规则名称' name='kpsq_spjd_content' rules={[{ required: true, message: '请输入规则名称' }]}>
                        <Input onChange={(e) => {setInfo(prev=>({...prev, 'kpsq_spjd_content': e.target.value}))}}/>
                    </Form.Item>
                    <Form.Item label='开票申请部门' name='kpsq_spjd_bm_id' wrapperCol={{ span: 10 }} required>
                        <Select options={deptList} onChange={(e,f) => {setInfo(prev=>({...prev, 'kpsq_spjd_bm_id':e, 'kpsq_spjd_bm_name':f.label}))}} />
                    </Form.Item>
                    <Form.Item label="审批点" required wrapperCol={{ span: 18 }}>
                        <Space size={10}>
                            <Form.Item  name="node_type" noStyle>
                                <Radio.Group
                                    onChange={(e) => {
                                        setInfo(prev=>({...prev, node_type: e.target.value}))
                                    }}
                                >
                                    <Radio value="审批">审批</Radio>
                                    <Radio value="抄送">抄送</Radio>
                                </Radio.Group>
                            </Form.Item>                           
                            <Form.Item name="node_user_id" noStyle>
                                <Select 
                                    options={useList} 
                                    onChange={(value, option) => {
                                        setInfo(prev => ({
                                            ...prev, 
                                            'node_user_id': value, 
                                            'node_user_name': option ? option.label : ''
                                        }));
                                    }} 
                                    style={{ width: '200px' }}
                                    placeholder={info.node_type === '审批' ? '请选择审批人' : '请选择抄送人'}
                                    disabled={info.node_type === ''}
                                />
                            </Form.Item>
                            <Icon 
                                type='add' 
                                onClick={() => {
                                if(!info.node_type){
                                    message.error('请选择节点类型')
                                    return;
                                }
                                if(!info.node_user_name){
                                    message.error('请选择操作员')
                                    return;
                                }
                                setNewNode(prev => [...prev, {
                                    title: info.node_type + '：' + info.node_user_name,
                                    content: '',
                                    status: 'wait',
                                    kpsq_spjd_name: info.node_type,
                                    kpsq_spjd_yh_id: info.node_user_id,
                                    kpsq_spjd_yh_name: info.node_user_name,
                                }]);
                                form.resetFields(['node_type', 'node_user_id', 'node_content']);
                                setInfo(prev => ({
                                    ...prev,
                                    node_type: '',
                                    node_user_name: '',
                                    node_content: '',
                                    node_user_id: '',
                                }));
                                }} title='添加审批节点' 
                            />
                        </Space>
                    </Form.Item>
                    <Form.Item wrapperCol={{ span: 18,offset: 6 }}>
                        {items.length===0 && ''}
                        <div>
                            <style>
                                {`
                                    .ant-steps-item-title {
                                        color: #000 !important;
                                    }
                                `}
                            </style>
                            <Steps
                                items={items}
                                orientation="vertical"  
                                size="small"
                                current={items.length-1}
                            />
                        </div>
                    </Form.Item>  
                    <Form.Item wrapperCol={{ span: 18,offset: 6 }}>
                      <Space size={30}>
                      <Icon type='save' onClick={onUpdate} title='保存' />
                      <Icon type='delete' onClick={onDelete} title='删除' />
                      </Space>
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                title='修改审批点'
                open={editNodeModalOpen}
                onOk={handleSaveEditNode}
                onCancel={() => {
                    setEditNodeModalOpen(false);
                    setEditingNodeIndex(-1);
                    editNodeForm.resetFields();
                    setEditNodeInfo({
                        node_type: '',
                        node_user_id: '',
                        node_user_name: '',
                    });
                }}
                width={500}
            >
                <Form form={editNodeForm} layout='vertical' name={`ruleInvoiceEditNodeForm_${props.kpsq_spjd_id}`}>
                    <Form.Item label='节点类型' name='node_type' rules={[{ required: true, message: '请选择节点类型' }]}>
                        <Radio.Group
                            value={editNodeInfo.node_type}
                            onChange={(e) => {
                                setEditNodeInfo(prev => ({...prev, node_type: e.target.value}));
                            }}
                        >
                            <Radio value="审批">审批</Radio>
                            <Radio value="抄送">抄送</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label='操作员' name='node_user_id' rules={[{ required: true, message: '请选择操作员' }]}>
                        <Select 
                            options={useList} 
                            value={editNodeInfo.node_user_id}
                            onChange={(value, option) => {
                                setEditNodeInfo(prev => ({
                                    ...prev, 
                                    'node_user_id': value, 
                                    'node_user_name': option ? option.label : ''
                                }));
                            }} 
                            placeholder={editNodeInfo.node_type === '审批' ? '请选择审批人' : '请选择抄送人'}
                            disabled={!editNodeInfo.node_type}
                        />                        
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

    export default RuleInvoiceEdit